<template>
  <jc-dialog ref="createDialog" :show.sync="show"
             btn-confirm-text='<i class="fas fa-save"></i> Lưu'

             title="Thêm mới"
             type="green"
             @onConfirm="$refs.form.submit()"
  >
    <c-form ref="form" @submit="submit()">
      <c-input v-model="model.name"
               label="Tên"
               validate-rules="required"
      />

      <c-input v-model="model.token"
               label="Mã xác thực"
               validate-rules="required"
      />

      <c-input v-model="model.description"
               label="Mô tả"
      />

    </c-form>
  </jc-dialog>
</template>

<script>
import dialogMixins from "@/mixins/dialogMixins";

export default {
  name: "add",
  mixins: [
    dialogMixins,
  ],
  data: function () {
    return {
      model: {
        name: null,
        token: null,
        description: null,
      },
    }
  },
  methods: {
    resetForm() {
      this.model = {
        name: null,
        token: null,
        description: null,
      }
    },
    submit: function () {
      this.$showLoader();
      let data = {
        "name": this.model.name,
        "token": this.model.token,
        "description": this.model.description
      }
      this.$http
          .post("/cms/api/v1.0/authenticate", data)
          .then(successRes => {
            this.close();
            this.$success();
            this.$stopLoader();

            this.$emit("success", successRes);
          }, errorRes => {
            this.$stopLoader();
            this.errorNotify(errorRes)
                .then(errorRes => this.$cmsBadRequest(errorRes));
            this.$emit("error", errorRes);
          })
      ;
    }
  }
}
</script>

<style scoped>

</style>